import { useEffect, useRef, useState } from 'react'
import maplibregl from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'
import MapUnavailable from './MapUnavailable'
import { isWebglAvailable } from '@/lib/helpers'

const MAP_STYLE =
  'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json'

/** Single-location map with one emerald pin, used on event detail. */
export default function MiniMap({
  longitude,
  latitude,
  color = 'var(--emerald-700)',
}: {
  longitude: number
  latitude: number
  color?: string
}) {
  const ref = useRef<HTMLDivElement>(null)
  const [failed, setFailed] = useState(() => !isWebglAvailable())

  useEffect(() => {
    if (failed || !ref.current) return
    let map: maplibregl.Map
    try {
      map = new maplibregl.Map({
        container: ref.current,
        style: MAP_STYLE,
        center: [longitude, latitude],
        zoom: 13,
        attributionControl: false,
      })
    } catch {
      setFailed(true)
      return
    }
    map.on('error', (e) => {
      if (e.error.message.includes('WebGL')) setFailed(true)
    })
    map.addControl(
      new maplibregl.NavigationControl({ showCompass: false }),
      'top-right',
    )
    const el = document.createElement('div')
    el.className = 'oumma-pin is-active'
    el.style.setProperty('--pin', color)
    el.innerHTML = '<span class="oumma-pin-star"></span>'
    new maplibregl.Marker({ element: el, anchor: 'bottom' })
      .setLngLat([longitude, latitude])
      .addTo(map)
    return () => map.remove()
  }, [longitude, latitude, color, failed])

  if (failed) {
    return (
      <div style={{ position: 'absolute', inset: 0 }}>
        <MapUnavailable latitude={latitude} longitude={longitude} />
      </div>
    )
  }
  return <div ref={ref} style={{ position: 'absolute', inset: 0 }} />
}
